module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<form>\n    <dl class=\'stepped zero\'>\n        <dt>\n            <label for=\'integration_name\'>' +
((__t = ( i18next.t('common.name') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <input class=\'text\' id=\'integration_name\' name=\'integration[name]\' value="' +
((__t = ( name )) == null ? '' : __t) +
'">\n        </dd>\n        <dt>\n            <label for=\'integration_reference_kind\'>' +
((__t = ( i18next.t('integrations.netmore.reference_kind') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <input class=\'text\' id=\'integration_reference_kind\' name=\'integration[reference_kind]\' value="' +
((__t = ( reference_kind )) == null ? '' : __t) +
'">\n        </dd>\n        <dt>\n            <label for=\'integration_reference_unit\'>' +
((__t = ( i18next.t('integrations.netmore.reference_unit') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <input class=\'text\' id=\'integration_reference_unit\' name=\'integration[reference_unit]\' value="' +
((__t = ( reference_unit )) == null ? '' : __t) +
'">\n        </dd>\n        <dt>\n            <label for=\'integration_reference_rate\'>' +
((__t = ( i18next.t('integrations.netmore.reference_rate') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <input class=\'text\' id=\'integration_reference_rate\' min=\'1\' name=\'integration[reference_rate]\' step=\'1\' type=\'number\' value="' +
((__t = ( reference_rate )) == null ? '' : __t) +
'">\n        </dd>\n    </dl>\n</form>\n';

}
return __p
}